import { Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { Form } from 'antd'

import {
  BillingAddressConfiguration,
  BillingConfiguration,
  FormFooter,
  FreightCalculationOptions,
  ProductMinimums,
} from './components'
import { useInvoiceConfigForm } from './hooks'
import type { InvoiceConfigurationTabProps } from './types'

export function InvoiceConfigurationTab({ ratebook, invoiceStatus, onChange }: InvoiceConfigurationTabProps) {
  const { form, isFormChanged, handleFormChange, handleSave, handleCancel } = useInvoiceConfigForm({
    ratebook,
    invoiceStatus,
    onChange,
  })

  const isPending = Form.useWatch('isPending', form) || false

  return (
    <Form form={form} onValuesChange={handleFormChange} layout='vertical' style={{ overflow: 'auto' }}>
      <Vertical
        border='top'
        bg='default'
        className='p-3'
        style={{ flex: '1 1 auto', minHeight: 'min-content' }}
        gap={12}
      >
        <Vertical>
          <FormFooter
            isFormChanged={isFormChanged}
            invoiceStatus={invoiceStatus}
            isPending={isPending}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </Vertical>

        <Vertical className='pt-4' style={{ overflow: 'visible' }}>
          <BillingConfiguration form={form} ratebook={ratebook} />
        </Vertical>

        <Horizontal justifyContent='space-between' gap={24}>
          <ProductMinimums form={form} ratebook={ratebook} onFormChange={handleFormChange} />
          <BillingAddressConfiguration form={form} ratebook={ratebook} />
        </Horizontal>

        <FreightCalculationOptions form={form} ratebook={ratebook} />
      </Vertical>
    </Form>
  )
}
